var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicinesBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.698149,
    y: 10.6591,
    width: 17,
    height: 5,
    rx: 2.5,
    transform: "rotate(-35.8705 0.698149 10.6591)",
    stroke: "#255986"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72401 9.19418L7.1809 5.97143L10.1107 10.0232L5.65378 13.2459C4.53493 14.0549 2.97207 13.8038 2.16304 12.6849C1.354 11.5661 1.60516 10.0032 2.72401 9.19418Z",
    fill: "#255986",
    stroke: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicinesBase);
export default __webpack_public_path__ + "static/media/medicines_base.0348e0134c8e344f13483e6ae1058f55.svg";
export { ForwardRef as ReactComponent };